import { React, useState } from "react";
import PropTypes from "prop-types";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import Parse from "../../../api/ApiConfig";
import { toast } from "react-toastify";
import { contentProps } from "../utils";
import { Backdrop, CircularProgress } from "@mui/material";
import { BsPlusLg } from "react-icons/bs";
import { HiMinus } from "react-icons/hi";

function SingleContent({
	index,
	singleChapterData,
	createChapterTemplate,
	chapters,
	setChapters,
	type,
}) {
	const [videoSrc, setVideoSrc] = useState("");
	const [loading, setLoading] = useState(false);
	const [thumbnailUrl, setThumbnailUrl] = useState("");
	const [isThumbnailSaved, setIsThumbnailSaved] = useState(false);
	const [isFileSaved, setIsFileSaved] = useState(false);

	//upload video
	const onChange = (info, type) => {
		if (info.file.status !== "done" && type === "video") {
			const url = URL.createObjectURL(info?.file);
			setVideoSrc(url);
			saveContentToParse(info); //set actual upload file to parse
		} else {
			if (info.file.status !== "done") {
				const url = URL.createObjectURL(info?.file);
				setThumbnailUrl(url);
				saveContentToParse(info, "thumbnail"); //set actual thumbnail file to parse
			}
		}
	};

	//stop ant design default behaviour
	const beforeUpload = (file, type) => {
		if (type === "video") {
			const url = URL.createObjectURL(file);
			setVideoSrc(url);
			return false;
		} else {
			const url = URL.createObjectURL(file);
			setThumbnailUrl(url);
			return false;
		}
	};

	//get chapter duration
	const handleLoadedMetadata = (e) => {
		// duration = e.target.duration;
		// console.log(e.target.duration);
		saveDuration(e.target.duration, singleChapterData?.id);
	};

	//get and save chapter duration
	const saveDuration = (contentDuration, durationId) => {
		console.log(contentDuration);
		let chapterCopy = [...chapters];
		chapterCopy = chapterCopy.map((data) => {
			if (data.id === durationId) {
				return {
					...data,
					duration: contentDuration,
				};
			} else {
				return data;
			}
		});
		setChapters(chapterCopy);
	};

	//handle change in form in each chapter and set the value to the chapter state
	const handleInputChange = (e, id) => {
		let chapterCopy = [...chapters];
		chapterCopy = chapterCopy.map((data, index) => {
			if (data.id === id) {
				return {
					...data,
					[e.target.name]: e.target.value,
					chapter: index + 1,
				};
			} else {
				return data;
			}
		});
		setChapters(chapterCopy);
	};

	//save video/audio/thumbnail url to the particular chapter using chapter's id
	const saveLink = (url, currentId, fileType) => {
		if (fileType) {
			let chapterCopy = [...chapters];
			chapterCopy = chapterCopy.map((data) => {
				if (data.id === currentId) {
					return {
						...data,
						coverPhoto: url,
					};
				} else {
					return data;
				}
			});
			setChapters(chapterCopy);
		} else {
			let chapterCopy = [...chapters];
			chapterCopy = chapterCopy.map((data) => {
				if (data.id === currentId) {
					return {
						...data,
						link: url,
						// duration: formatDuration(currentDuration),
					};
				} else {
					return data;
				}
			});
			setChapters(chapterCopy);
		}
	};

	//host video/thumbnail url on parse
	const saveContentToParse = async (data, fileType) => {
		setLoading(true);
		try {
			const sanitizedFileName = data?.file.name.replace(/[^\w.-]+/g, "");
			const ContentFile = new Parse.File(sanitizedFileName, data?.file);
			await ContentFile.save();
			if (fileType) {
				console.log("save thumbnail to parse url");
				saveLink(ContentFile?._url, singleChapterData?.id, fileType);
				toast.success("Thumbnail successfully saved");
				setIsThumbnailSaved(true);
			} else {
				saveLink(ContentFile?._url, singleChapterData?.id); //save content  url to its state data
				setIsFileSaved(true);
				if (type === "audio") {
					toast.success("Audio file saved successfully");
				} else {
					toast.success("Video file saved successfully");
				}
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
			console.log(error);
			toast.error("unable to save  file, please try again later");
			console.error("Error saving item:", error);
		}
	};

	const removeChapter = () => {
		let chapterCopy = [...chapters];
		chapterCopy = chapterCopy.filter(
			(data) => data.id !== singleChapterData?.id
		);
		setChapters(chapterCopy);
	};

	return (
		<div className='mt-4'>
			<header className='flex space-between'>
				<h2 style={{ fontWeight: "bold", fontSize: "1rem" }}>
					CHAPTER {index + 1}
				</h2>

				<div className='flex flex-col gap-2'>
					<div className='flex gap-2 pointer' onClick={createChapterTemplate}>
						<BsPlusLg size={18} /> Add more chapters
					</div>
					{chapters.length > 1 && (
						<div onClick={removeChapter} className='flex gap-2 pointer'>
							<HiMinus size={18} /> Remove chapter
						</div>
					)}
				</div>
			</header>
			<div className='form-group'>
				<label>TITLE</label>
				<input
					style={{ cursor: "text" }}
					name='name'
					className='w-full border padding'
					onChange={(e) => handleInputChange(e, singleChapterData?.id)}
					value={singleChapterData?.name}
					required={true}
				/>
			</div>

			<div className='form-group'>
				<label>DESCRIPTION</label>
				<textarea
					style={{ cursor: "text" }}
					name='description'
					className='w-full border padding'
					onChange={(e) => handleInputChange(e, singleChapterData?.id)}
					value={singleChapterData?.description}
					required={true}
				/>
			</div>

			<div className='form-group'>
				{type === "audio" ? (
					<label>UPLOAD AUDIO</label>
				) : (
					<label>UPLOAD VIDEO</label>
				)}
				<Upload
					// onChange={onChange}
					onChange={(e) => onChange(e, "video")}
					{...contentProps}
					beforeUpload={(e) => beforeUpload(e, "video")}
					accept={type === "audio" ? "audio/*" : "video/*"}
				>
					<Button
						style={{ color: "#959595", fontSize: "1rem" }}
						icon={<UploadOutlined style={{ fontSize: "1.2rem" }} />}
					>
						Click to upload
					</Button>
				</Upload>
			</div>

			{isFileSaved && type == "video" ? (
				<video
					autoPlay={false}
					controls
					playsInline
					src={videoSrc}
					width={"100%"}
					height={"200"}
					onLoadedMetadata={handleLoadedMetadata}
				>
					<source src={videoSrc} type='video/webm' />
					<source src={videoSrc} type='video/mp4' />
					<p>
						Your browser doesnt support HTML video. Here is a
						<a href={videoSrc}>link to the video</a> instead.
					</p>
				</video>
			) : null}

			{isFileSaved && type == "audio" ? (
				<audio
					className='mt-8'
					autoPlay={false}
					controls
					src={videoSrc}
					onLoadedMetadata={handleLoadedMetadata}
				>
					<source src={videoSrc} type='audio/mpeg' />
					<source src={videoSrc} type='audio/ogg' />

					<p>
						Your browser doesnt support HTML audio. Here is a
						<a href={videoSrc}>link to the audio</a> instead.
					</p>
				</audio>
			) : null}

			<div className='form-group'>
				{type === "audio" ? (
					<label className='mt-4'>UPLOAD AUDIO THUMBNAIL</label>
				) : (
					<label className='mt-4'>UPLOAD VIDEO THUMBNAIL</label>
				)}
				<Upload
					// onChange={thumbnailUpload}
					onChange={(e) => onChange(e, "thumbnail")}
					{...contentProps}
					beforeUpload={(e) => beforeUpload(e, "thumbnail")}
					accept='image/*'
				>
					<Button
						style={{ color: "#959595", fontSize: "1rem" }}
						icon={<UploadOutlined style={{ fontSize: "1.2rem" }} />}
					>
						Click to upload
					</Button>
				</Upload>
			</div>
			{isThumbnailSaved ? (
				<img
					className='mt-6'
					style={{ objectFit: "contain", height: "20rem" }}
					alt='thumbnail'
					src={thumbnailUrl}
				/>
			) : null}

			{loading && (
				<Backdrop
					sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={loading}
				>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</div>
	);
}

SingleContent.propTypes = {
	index: PropTypes.number,
	singleChapterData: PropTypes.object,
	chapters: PropTypes.array,
	setChapters: PropTypes.func,
	createChapterTemplate: PropTypes.func,
	type: PropTypes.string,
};

export default SingleContent;
